import React from 'react'
import styles from './styles.module.scss'

function GroupMillPure({ type, groupType = 'interest', size, picture, renderIcon }) {
  return (
    <div className={`${styles.picture} ${styles[size]}`}>
      {type === 'mixr' && <div className={styles.mixrIndicator}>{renderIcon && renderIcon()}</div>}
      {type === 'group' && groupType === 'expertise' && (
        <div className={styles.expertiseIndicator}>{renderIcon && renderIcon()}</div>
      )}
      {picture ? (
        <img src={picture} alt='' />
      ) : (
        <img src={require('../../../assets/images/background-default-mixr.jpg')} alt='' />
      )}
    </div>
  )
}

export default GroupMillPure
